const vehicleTypeOptions = [
  { value: 'car', label: 'Car' },
  { value: 'taxi', label: 'Taxi' },
  { value: 'van', label: 'Van' },
  { value: 'caravan', label: 'Caravan' },
  { value: 'motorbike', label: 'Motorbike' }
]

export default vehicleTypeOptions
